import { render, staticRenderFns } from "./RetailersFilterButton.vue?vue&type=template&id=3b1d78d0&scoped=true&lang=pug"
import script from "./RetailersFilterButton.vue?vue&type=script&lang=js"
export * from "./RetailersFilterButton.vue?vue&type=script&lang=js"
import style0 from "./RetailersFilterButton.vue?vue&type=style&index=0&id=3b1d78d0&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1d78d0",
  null
  
)

export default component.exports